import React, { useState } from "react";
import { Row, Table, Image } from "react-bootstrap";
import { Paper, InputBase, IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Filter from "../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import TableSizePopup from "../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import { SeatingStatus } from "../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";

const SeatingReportsDashboard = () => {
  //state
  const [state, setState] = useState({
    search: "",
    open: false,
    showStatus: "All",
    showStatusText: "",
  });
  const [statePax, setStatePax] = useState({
    showPax: "All",
    showPaxText: "",
    openPax: false,
  });
  const onSearchChange = (e) => {
    setState({
      search: e.target.value,
    });
  };
  /****************************************
   * @DESC Ope Modal
   ***************************************/
  const onOpenModal = () => {
    setState({ open: true });
  };
  const onCloseModal = () => {
    setState({ open: false });
  };
  const onOpenModalPax = () => {
    setStatePax({ openPax: true });
  };
  const onCloseModalPax = () => {
    setStatePax({ openPax: false });
  };
  /****************************************
   * @DESC Big Button Show Status Handler
   ***************************************/
  const bigButtonShowStatusHandler = (e, type) => {
    // e.preventDefault();
    setState({
      showStatus: type,
      showStatusText: type,
    });
  };
  const selectStatusClick = (e) => {
    setState({
      showStatus: state.showStatusText === "" ? "All" : state.showStatusText,
      open: false,
    });
  };
  const bigButtonShowPaxHandler = (e, type) => {
    // e.preventDefault();
    setStatePax({
      showPax: type,
      showPaxText: type,
    });
  };
  const selectPaxClick = (e) => {
    setStatePax({
      showPax: statePax.showPaxText === "" ? "All" : statePax.showPaxText,
      openPax: false,
    });
  };
  return (
    <React.Fragment>
      <Row>
        <div className="col-md-5 seating-topbar-search">
          <div className="filter-button">
            <Filter />
          </div>
          <div className="filter-button-border-left"></div>
          <div className="filter-button-search">
            {/* <Form.Control
              type="text"
              placeholder="Search"
              onChange={onSearchChange}
              value={state.search}
              className="amSearch"
            /> */}
            <Paper component="form" className="enSearch2 d-flex">
              <IconButton type="submit" aria-label="search">
                <SearchIcon />
              </IconButton>
              <InputBase
                placeholder="Search"
                className="w-100"
                inputProps={{
                  "aria-label": "Search by Name or Phone Number",
                }}
                onChange={onSearchChange}
                value={state.search}
              />
            </Paper>
          </div>
          <div className="filter-button-qrcode">
            <div className="filter-button-qrcode-box">
              <img
                src={require("../../../../assets/images/ActionImages/image/qrcode.svg")}
                className="img-fluid"
                alt="QR Scan"
                title="QR Scan"
              />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="row">
            <div className="col-6">
              <SeatingStatus
                status={state.showStatus}
                onOpenModal={onOpenModal}
                onCloseModal={onCloseModal}
                open={state.open}
                seatingStatus={state.showStatusText}
                onClickAll={(e) => bigButtonShowStatusHandler(e, "All")}
                onClickSeated={(e) => bigButtonShowStatusHandler(e, "Seated")}
                onClickNonSeated={(e) =>
                  bigButtonShowStatusHandler(e, "Not Seated")
                }
                onStatusClick={selectStatusClick}
              />
            </div>
            <div className="col-6">
              <TableSizePopup
                showPax={statePax.showPax}
                onOpenModal={onOpenModalPax}
                open={statePax.openPax}
                onCloseModal={onCloseModalPax}
                table_size={statePax.showPaxText}
                onClickAll={(e) => bigButtonShowPaxHandler(e, "All")}
                onClickTwo={(e) => bigButtonShowPaxHandler(e, "2")}
                onClickFour={(e) => bigButtonShowPaxHandler(e, "4")}
                onClickSix={(e) => bigButtonShowPaxHandler(e, "6")}
                onClickEight={(e) => bigButtonShowPaxHandler(e, "8")}
                graterThanEight={(e) => bigButtonShowPaxHandler(e, "8>")}
                selectPaxClick={selectPaxClick}
              />
            </div>
          </div>
        </div>
      </Row>
      <div>
        <div className="mt-4 user-table-reusable-superadmin table-responsive">
          <Table className="enMinWidth900 HideShowTable">
            <thead>
              <tr className="super_admin_all_users_table_head">
                <th style={{ width: "25%" }} className="f12-700">
                  Name /<br />
                  Request Number
                </th>
                <th style={{ width: "25%" }} className="f12-700">
                  Total PAX
                </th>
                <th style={{ width: "20%" }} className="f12-700">
                  Date / Time
                  <br />
                  Timer<div className="f9-400">(HH:MM:SS)</div>
                </th>
                <th style={{ width: "15%" }} className="f12-700">
                  Status
                  <br />
                  Location
                </th>
                <th
                  style={{ width: "15%", textAlign: "center" }}
                  className="f12-700"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="enLeftGReenLine super_admin_all_users_table_body">
                <td style={{ width: "25%" }}>
                  <div className="d-flex">
                    <div>
                      <Image
                        src={require("../../../../assets/images/UserManagement/walkin.svg")}
                        alt="View"
                        title="View"
                        width="9px"
                      />
                    </div>
                    <div className="pl-2">
                      <div className="f12-500">Chandrashekhar Narayan</div>
                      <div className="f9-400">#1234567890</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "25%" }}>
                  <div className="adult-total-box">
                    <div className="d-flex align-items-center">
                      <p className="f18-700 text-dark mr-2">30</p>
                      <div className="adult-total-box-two mr-2">
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/employees.png")}
                              fluid
                              alt="Adult"
                              title="Adult"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">11</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/children.png")}
                              fluid
                              alt="Children"
                              title="Children"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">11</span>
                        </div>
                      </div>
                      <div className="adult-total-box-three">
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/highchair.png")}
                              fluid
                              alt="Highchair"
                              title="Highchair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">11</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                              fluid
                              alt="Wheel Chair"
                              title="Wheel Chair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">11</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500">
                    25th Aug, 2020
                    <br />
                    12:15 PM
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f13-400">
                    <span className="enGreenDot mr-1"></span>
                    Seated
                  </div>
                </td>
                <td style={{ width: "15%", textAlign: "center" }}>
                  <div className="f9-400 mb-2">Total wait time</div>
                  <div className="m-auto d-flex justify-content-center align-items-center enTimesLbl">
                    <Image
                      src={require("../../../../assets/images/UserManagement/hourglass.svg")}
                      alt="Edit"
                      title="Edit"
                      width="9px"
                    />
                    <span className="f10-500 text-dark pl-2">
                      00 hh : 20 mins
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </React.Fragment>
  );
};
export default SeatingReportsDashboard;
// import React, { Component } from "react";
// import Accordion from "react-bootstrap/Accordion";
// import { SeatingDashboardDesktopTableHead } from "../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardDesktopTableHead";
// import { SeatingDashboardMobile } from "../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardMobile";
// import { SeatingDashboardBody } from "../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardBody";

// export class SeatingReportsDashboard extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       displaySearch: false,
//       open: false,
//       openDefaultWaitTime: false,
//       openPax: false,
//       selectedPage: 1,
//       showStatus: "All",
//       defaultWaitTime: "00-05",
//       showPax: "All",
//     };
//   }

//   /****************************************
//    * @DESC Ope Modal
//    ***************************************/
//   onOpenModal = () => {
//     this.setState({ open: true });
//   };
//   onCloseModal = () => {
//     this.setState({ open: false });
//   };
//   onOpenModalPax = () => {
//     this.setState({ openPax: true });
//   };
//   onCloseModalPax = () => {
//     this.setState({ openPax: false });
//   };

//   /****************************************
//    * @DESC Big Button Show Status Handler
//    ***************************************/
//   bigButtonShowStatusHandler = (e, type) => {
//     e.preventDefault();
//     this.setState({
//       showStatus: type,
//       open: false,
//     });
//   };

//   bigButtonShowPaxHandler = (e, type) => {
//     e.preventDefault();
//     this.setState({
//       showPax: type,
//       openPax: false,
//     });
//   };

//   searchButton = (e) => {
//     e.preventDefault();
//     this.setState({
//       displaySearch: true,
//     });
//   };

//   searchButtonClose = (e) => {
//     e.preventDefault();
//     this.setState({ displaySearch: false });
//   };

//   /****************************************
//    * @DESC Seating Desktop View Components
//    ***************************************/
//   renderSeatingCardView = () => {
//     return (
//       <React.Fragment>
//         <SeatingDashboardBody
//           displayCall={true}
//           displaySms={true}
//           displayNotification={true}
//           displayChat={true}
//           displayViewDiner={true}
//           displayEditDiner={true}
//           totalCount="30"
//           totalAdult="11"
//           totalKids="19"
//           totalHighchair="02"
//           totalHandicapped="01"
//           displayButton={true}
//         />
//       </React.Fragment>
//     );
//   };

//   /****************************************
//    * @DESC Seating Mobile View Components
//    ***************************************/
//   renderSeatingAccordian = () => {
//     return (
//       <React.Fragment>
//         <SeatingDashboardMobile
//           indexKey="0"
//           dinnerId={"#1234567890"}
//           dinnerOrderType={"walkin"}
//           dinnerName={"Chandrashekhar"}
//           totalCount="30"
//           totalAdult="11"
//           totalKids="19"
//           totalHighchair="02"
//           totalHandicapped="01"
//           displayLocation={true}
//           date="25Th Aug,2020"
//           time="07:30 AM"
//           displayButton={"cancel"}
//           seatingPreference="Outdoor"
//           displayButtonTwo={"save"}
//           displayCall={true}
//           displaySms={true}
//           displayNotification={true}
//           displayChat={true}
//           displayViewDiner={true}
//           displayEditDiner={true}
//           tableNo="A-123"
//           roomNo="A-123"
//           specialOcassion="Graduation 20th Anniversa ry and my Dog’s Birthday…"
//           status="Not-seated"
//         />
//       </React.Fragment>
//     );
//   };

//   render() {
//     return (
//       <React.Fragment>
//         <div className="col-12">
//           {/*******************************
//            *  @DESC Seating Desktop View
//            *******************************/}
//           <div className="row seating-dashboard-desktop-table">
//             <SeatingDashboardDesktopTableHead />
//             {this.renderSeatingCardView()}
//           </div>

//           {/*******************************
//            *  @DESC Seating Mobile View
//            *******************************/}
//           <div className="row seating-dashboard-table">
//             <div className="col-5">
//               <p className="top-heading-text">Name</p>
//             </div>
//             <div className="col-4">
//               <p className="top-heading-text">Total</p>
//             </div>
//             <div className="col-3">
//               <p className="top-heading-text">Timer</p>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-12 p-0">
//               <Accordion>{this.renderSeatingAccordian()}</Accordion>
//             </div>
//           </div>
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// export default SeatingReportsDashboard;
